import FormContainer from "@app/components/forms/container/FormContainer";
import { useFormWithSchema } from "@app/components/forms/hooks/useFormWithSchema";
import {
  FormFieldSchema,
  FormFieldType,
} from "@app/components/forms/types/schema";
import { Select } from "@shortsworks/ui";
import { useGetStoryGroupList } from "@shortsworks/user-api";
import { LoaderCircle } from "lucide-react";
import { useEffect } from "react";
import * as React from "react";

interface GroupSelectorProps extends React.HTMLAttributes<HTMLElement> {
  groupIds: string[];
  onChangeGroupIds: (groupIds: string[]) => void;
}

interface StoryGroupListFormProps {
  formSchemas: FormFieldSchema[];
}

export const GroupSelector = ({
  groupIds,
  onChangeGroupIds,
  ...props
}: GroupSelectorProps) => {
  const { data: storyGroupListData, isSuccess: isSuccessGetStoryGroupList } =
    useGetStoryGroupList();
  if (!isSuccessGetStoryGroupList) {
    return;
  }

  const activatedGroupList = storyGroupListData.data.filter(
    (group) => !group.isDisabled,
  );
  const storyGroupListSchema: FormFieldSchema[] = [
    {
      type: FormFieldType.MultiSelect,
      id: "groupIds",
      label: "그룹 목록",
      defaultValue: groupIds,
      placeholder: "전체",
      options: activatedGroupList.map((group) => {
        return {
          label: group.name,
          value: group.id,
        };
      }),
    },
  ];

  const StoryGroupListForm = ({ formSchemas }: StoryGroupListFormProps) => {
    const {
      schemas: groupSchemas,
      form: groupForm,
      formValues: groupListFormValues,
    } = useFormWithSchema({
      formSchemas,
      defaultFormValues: {
        groupIds: groupIds,
      },
    });

    useEffect(() => {
      if (
        JSON.stringify(groupIds) ===
        JSON.stringify(groupListFormValues.groupIds)
      ) {
        return;
      }
      return onChangeGroupIds(groupListFormValues.groupIds);
    }, [groupListFormValues]);

    return <FormContainer {...props} schemas={groupSchemas} form={groupForm} />;
  };

  return <StoryGroupListForm formSchemas={storyGroupListSchema} />;
};
